import axiosCall from './interceptor';
import URL from '../helper';

export const createChart = async payload => {
  const url = `${URL.DESIGN_SYSTEM_URL}chart/create`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};

export const createBarChart = async payload => {
  const url = `${URL.DESIGN_SYSTEM_URL}chart/create/bar`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};
